(() => {
  const gallery = document.getElementById('offers-media-gallery');
  if (!gallery) return;
  const videos = [...gallery.querySelectorAll('video[data-src]')];
  const visible = new Set();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  function syncPlayback() {
    videos.forEach(video => {
      if (!visible.has(video) || document.hidden || reducedMotion.matches || connection?.saveData) {
        video.pause();
        return;
      }
      if (!video.hasAttribute('src')) {
        video.muted = true;
        video.defaultMuted = true;
        video.src = video.dataset.src;
        video.load();
      }
      video.play().catch(() => {});
    });
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.intersectionRatio >= .5) visible.add(entry.target);
      else visible.delete(entry.target);
    });
    syncPlayback();
  }, {threshold: [0, .5]});
  videos.forEach(video => observer.observe(video));
  reducedMotion.addEventListener('change', syncPlayback);
  connection?.addEventListener('change', syncPlayback);
  document.addEventListener('visibilitychange', syncPlayback);
})();
